import { useState } from "react";
import { useOutletContext } from "react-router-dom";

import { AiOutlineLoading3Quarters } from "react-icons/ai";
import MCubeLogo from "./MCubeLogo";

import useMCubeEngageConfiguration from "./useMCubeEngageConfiguration";
import MCubeEngageForm from "./MCubeEngageForm";
import MCubeEngageWhatsappManager from "./MCubeEnageWhatsappManager";
import MCubeEngageShell from "./MCubeEngageShell";
import MCubeEngageEditConfiguration from "./MCubeEngageEditConfiguration";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default MCubeEngage;

function MCubeEngageWhatsappManagerTitle() {
  return (
    <div className="flex gap-x-2 items-center">
      <MCubeLogo />
      <h3 className="text-base font-semibold">MCube Engage</h3>
    </div>
  );
}

function MCubeEngageWhatsappConigurationLoading() {
  return (
    <div className="flex flex-col gap-y-4">
      <MCubeEngageWhatsappManagerTitle />
      <div className="min-h-96 flex items-center justify-center border rounded-lg max-w-lg">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    </div>
  );
}

function MCubeEngageWhatsappConfigured(props) {
  const {
    isViewOnly,
    configuration,
    fetchConfiguration,
    updateConfiguration,
    deleteConfiguration,
    workspaceId,
  } = props;

  const [editConfiguration, setEditConfiguration] = useState(false);

  const handleOpen = () => setEditConfiguration(true);
  const handleClose = () => setEditConfiguration(false);

  const handleDisconnect = async () => {
    function init() {
      message.loading("Disconnecting MCube Engage");
    }

    function success() {
      message.destroy();
      message.success("MCube Engage disconnected");
    }

    function error(e) {
      message.destroy();
      showErrorToast(e, "Failed to disconnect MCube Engage");
    }

    deleteConfiguration({ init, success, error });
  };

  return (
    <>
      <MCubeEngageShell
        title={<MCubeEngageWhatsappManagerTitle />}
        isViewOnly={isViewOnly}
        onConfigure={handleOpen}
        onDisconnect={handleDisconnect}
      >
        <MCubeEngageWhatsappManager
          isViewOnly={isViewOnly}
          workspaceId={workspaceId}
          configuration={configuration}
          fetchConfiguration={fetchConfiguration}
        />
      </MCubeEngageShell>
      {editConfiguration && (
        <MCubeEngageEditConfiguration
          onClose={handleClose}
          configuration={configuration}
          onUpdateConfiguration={updateConfiguration}
        />
      )}
    </>
  );
}

function MCubeEngageWhatsappConfigure(props) {
  const { registerMcubeEngageConfiguration, isViewOnly } = props;

  return (
    <div className="max-w-md flex flex-col gap-y-4">
      <MCubeEngageWhatsappManagerTitle />
      <div className="border rounded-lg p-8">
        <MCubeEngageForm
          registerMcubeEngageConfiguration={registerMcubeEngageConfiguration}
          isViewOnly={isViewOnly}
        />
      </div>
    </div>
  );
}

function MCubeEngage() {
  const { projectId, isViewOnly } = useOutletContext<{
    projectId: string;
    isViewOnly: boolean;
  }>();

  const {
    isConfigured,
    isLoading,
    mcubeEngageConfiguration,
    fetchMcubeEngageConfiguration,
    registerMcubeEngageConfiguration,
    updateMcubeEngageConfiguration,
    deleteMCubeEngageConfiguration,
  } = useMCubeEngageConfiguration(projectId);

  const isNotConfigured = !isLoading && !isConfigured;

  if (isLoading) {
    return <MCubeEngageWhatsappConigurationLoading />;
  }

  if (isNotConfigured) {
    return (
      <MCubeEngageWhatsappConfigure
        workspaceId={projectId}
        isViewOnly={isViewOnly}
        registerMcubeEngageConfiguration={registerMcubeEngageConfiguration}
      />
    );
  }

  return (
    <MCubeEngageWhatsappConfigured
      workspaceId={projectId}
      isViewOnly={isViewOnly}
      configuration={mcubeEngageConfiguration}
      fetchConfiguration={fetchMcubeEngageConfiguration}
      updateConfiguration={updateMcubeEngageConfiguration}
      deleteConfiguration={deleteMCubeEngageConfiguration}
    />
  );
}
